var _defs, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSzukaj(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 239.5 133.34",
    width: 67,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n            .d {\r\n            fill: none;\r\n            stroke-linecap: round;\r\n            stroke-miterlimit: 10;\r\n            stroke-width: 10px;\r\n            }\r\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    "data-name": "Layer 1"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "b",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "c",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 83.58,
    y1: 90.98,
    x2: 103.72,
    y2: 91.23
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#fff",
    cx: 162.25,
    cy: 74.08,
    r: 43.73
  }), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 216.51,
    y1: 128.34,
    x2: 193.17,
    y2: 105.01
  })), /*#__PURE__*/React.createElement("line", {
    className: "d",
    stroke: "#fff",
    x1: 58.25,
    y1: 42.06,
    x2: 108.78,
    y2: 45.03
  }), /*#__PURE__*/React.createElement("circle", {
    className: "d",
    stroke: "#fff",
    cx: 47.82,
    cy: 87.4,
    r: 18.58
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "d",
    stroke: "#fff",
    points: "193.32 42.71 229.19 54.67 234.5 74.13 234.5 91.83 219.58 91.83"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    stroke: "#fff",
    d: "M16.78,90.94h-7.89l-3.83-19.81c-.88-4.54,8.26-28.87,8.26-28.87,0,0,3.16-7.06,7.06-7.06l22.79-.68,14.99-21.4c5.2-5.2,12.25-8.12,19.6-8.12h58.89c6.93,0,13.6,2.65,18.64,7.42l20.73,19.6"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSzukaj);
export default __webpack_public_path__ + "static/media/szukaj.be6c969f7535fb22b125f28db60e7045.svg";
export { ForwardRef as ReactComponent };